module.exports = __webpack_public_path__ + "img/preacher-mentor-2.753dad08.svg";